// import axios from 'axios'; // 현재 미사용으로 주석 처리
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { TOKEN_KEY, TOKEN_TYPE_KEY, USER_KEY, REFRESH_TOKEN_KEY, ID_TOKEN_KEY, LOGOUT_STATE_KEY, TOKEN_ENDPOINT_URL_KEY, ACCESS_TOKEN_EXPIRES_AT_KEY } from '../types';
import { tokenManager } from '../token-manager';
// Base implementation with common functionality
export var BaseAuthHandler = /*#__PURE__*/ function() {
    "use strict";
    function BaseAuthHandler(authServerUrl) {
        _class_call_check(this, BaseAuthHandler);
        _define_property(this, "authServerUrl", void 0);
        _define_property(this, "apiService", null) // Optional API service injection
        ;
        this.authServerUrl = authServerUrl;
    }
    _create_class(BaseAuthHandler, [
        {
            /**
   * Set external API service for making user profile requests
   */ key: "setApiService",
            value: function setApiService(apiService) {
                var _this = this;
                this.apiService = apiService;
                // Set the token callback for the token manager
                tokenManager.setTokenSetCallback(function(token, tokenType) {
                    if (_this.apiService && _this.apiService.setToken) {
                        _this.apiService.setToken(token, tokenType);
                    }
                });
            }
        },
        {
            key: "getCurrentUser",
            value: /**
   * Generic getCurrentUser implementation
   */ function getCurrentUser(setState) {
                var _this = this;
                return _async_to_generator(function() {
                    var token, storedUserJson, user;
                    return _ts_generator(this, function(_state) {
                        console.log('[BaseAuthHandler] Getting current user...');
                        token = localStorage.getItem(TOKEN_KEY);
                        storedUserJson = localStorage.getItem(USER_KEY);
                        if (!token) {
                            console.log('[BaseAuthHandler] No token found for getCurrentUser.');
                            setState(function(current) {
                                return _object_spread_props(_object_spread({}, current), {
                                    user: null,
                                    isAuthenticated: false,
                                    token: null
                                });
                            });
                            return [
                                2,
                                {
                                    user: null,
                                    isAuthenticated: false
                                }
                            ];
                        }
                        user = null;
                        // Try to load user from localStorage first
                        if (storedUserJson) {
                            try {
                                user = JSON.parse(storedUserJson);
                                setState(function(current) {
                                    return _object_spread_props(_object_spread({}, current), {
                                        user: user,
                                        isAuthenticated: true,
                                        token: token
                                    });
                                });
                                return [
                                    2,
                                    {
                                        user: user,
                                        isAuthenticated: true
                                    }
                                ];
                            } catch (e) {
                                console.error('[BaseAuthHandler] Failed to parse stored user:', e);
                            }
                        }
                        // If no stored user and we have an API service, try to fetch user profile
                        if (_this.apiService && _this.apiService.userApi) {
                            try {
                                // This would require the username to be stored separately or extracted from token
                                console.warn('[BaseAuthHandler] API service available but no username found in storage');
                            } catch (error) {
                                console.error('[BaseAuthHandler] Failed to get user profile:', error);
                            }
                        }
                        // Fallback: if we have a token but no user data, consider partially authenticated
                        setState(function(current) {
                            return _object_spread_props(_object_spread({}, current), {
                                user: null,
                                isAuthenticated: !!token,
                                token: token
                            });
                        });
                        return [
                            2,
                            {
                                user: null,
                                isAuthenticated: !!token
                            }
                        ];
                    });
                })();
            }
        },
        {
            key: "setAuthenticatedState",
            value: /**
   * Generic setAuthenticatedState implementation
   */ function setAuthenticatedState(user, token, refreshToken, expiresIn, setState) {
                var tokenType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 'Bearer', idToken = arguments.length > 6 ? arguments[6] : void 0;
                var _this = this;
                return _async_to_generator(function() {
                    var newExpiresAt, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('[BaseAuthHandler] Setting authenticated state:', {
                                    user: user.username,
                                    hasToken: !!token,
                                    hasRefreshToken: !!refreshToken,
                                    expiresIn: expiresIn,
                                    tokenType: tokenType
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    2,
                                    ,
                                    4
                                ]);
                                // Set token and metadata in token manager (which will notify API service)
                                tokenManager.setToken(token, tokenType);
                                tokenManager.setRefreshToken(refreshToken !== null && refreshToken !== void 0 ? refreshToken : null);
                                if (expiresIn) {
                                    tokenManager.setExpiresIn(expiresIn);
                                }
                                setState(function() {
                                    return {
                                        user: user,
                                        token: token,
                                        isAuthenticated: true
                                    };
                                });
                                localStorage.setItem(TOKEN_KEY, token);
                                localStorage.setItem(TOKEN_TYPE_KEY, tokenType);
                                localStorage.setItem(USER_KEY, JSON.stringify(user));
                                // ID 토큰 저장 (OIDC 로그아웃에 필요)
                                if (idToken) {
                                    localStorage.setItem(ID_TOKEN_KEY, idToken);
                                    console.log('[BaseAuthHandler] ID token stored for OIDC logout');
                                } else {
                                    localStorage.removeItem(ID_TOKEN_KEY);
                                }
                                if (refreshToken) {
                                    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
                                    console.warn('🚨 보안 권고: 리프레시 토큰을 localStorage 대신 httpOnly 쿠키로 저장하세요!');
                                } else {
                                    localStorage.removeItem(REFRESH_TOKEN_KEY);
                                }
                                if (expiresIn) {
                                    newExpiresAt = Date.now() + expiresIn * 1000;
                                    localStorage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, newExpiresAt.toString());
                                }
                                console.log('[BaseAuthHandler] Authenticated state set successfully.');
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                error = _state.sent();
                                console.error('[BaseAuthHandler] Failed to set authenticated state:', error);
                                return [
                                    4,
                                    _this.logout(setState)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearAuthStorage",
            value: /**
   * Helper method to clear all auth-related localStorage
   */ function clearAuthStorage() {
                var preserveLogoutState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                console.log('[BaseAuthHandler] Clearing auth storage.');
                tokenManager.clearToken();
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(TOKEN_TYPE_KEY);
                localStorage.removeItem(USER_KEY);
                localStorage.removeItem(REFRESH_TOKEN_KEY);
                localStorage.removeItem(ID_TOKEN_KEY);
                localStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY);
                localStorage.removeItem(TOKEN_ENDPOINT_URL_KEY);
                if (!preserveLogoutState) {
                    localStorage.removeItem(LOGOUT_STATE_KEY);
                }
            }
        },
        {
            key: "generateRandomState",
            value: /**
   * Helper to generate random state for OIDC flows
   */ function generateRandomState() {
                return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            }
        }
    ]);
    return BaseAuthHandler;
}();
